<template>
    <section class="relative z-10 " aria-labelledby="contact-heading">
        <p class="py-8 text-3xl text-center text-white bg-clay-500"><span
                class="inline mr-1 italic text-gray-200">Near:</span>{{
            getContentResponse.locationFormattedAddress}}
        </p>
        <div class="px-4 pb-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div class="pt-12 border border-t-0 border-b-2 border-x-0">
                <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div class="relative sm:overflow-hidden">

                        <div class="relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8">
                            <h4 class="text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl"
                                id="auditions">
                                Auditions &amp; Jobs
                            </h4>
                            <h2 class="pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl">
                                Audition notices and job opportunities in theatre
                            </h2>

                        </div>
                    </div>
                </div>

                <SkeletonCard class="mt-4" v-if="isFetching" card-style="long" :num-of-cards=2 />
                <div v-else
                    class="grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-x-8">
                    <div v-for="audition in getContentResponse.auditions" :key="audition.id">
                        <OpportunityCard :opportunity="audition" />
                    </div>
                </div>

                <div class="px-8">
                    <a href="/opportunities/theatre-auditions"
                        class="block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700 ">
                        View all auditions & jobs</a>
                </div>

            </div>
            <div class="pt-12 border border-t-0 border-b-2 border-x-0">
                <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div class="relative sm:overflow-hidden">

                        <div class="relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8">
                            <h4 class="text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl"
                                id="classes">
                                Classes & Camps
                            </h4>
                            <h2 class="pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl">
                                Improve your craft with theatre classes, camps and webinars
                            </h2>

                        </div>
                    </div>
                </div>

                <SkeletonCard class="mt-4" v-if="isFetching" card-style="long" :num-of-cards=2 />
                <div v-else
                    class="grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-x-8">
                    <div v-for="opportunity in getContentResponse.classes" :key="opportunity.id">
                        <OpportunityCard :opportunity="opportunity" />
                    </div>
                </div>

                <div class="px-8">
                    <a href="/opportunities/theatre-education"
                        class="block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700 ">
                        View all classes & camps
                    </a>
                </div>

            </div>
            <div class="pt-12 border border-t-0 border-b-2 border-x-0">
                <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div class="relative sm:overflow-hidden">

                        <div class="relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8">
                            <h4 class="text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl"
                                id="performances">
                                Performances
                            </h4>
                            <h2 class="pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl">
                                Theatre performances and festivals. Musicals, plays, operas and more!
                            </h2>

                        </div>
                    </div>
                </div>

                <SkeletonCard class="mt-4" v-if="isFetching" card-style="long" :num-of-cards=2 />
                <div v-else
                    class="grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-x-8">
                    <div v-for="performance in getContentResponse.performances" :key="performance.id">
                        <OpportunityCard :opportunity="performance" />
                    </div>
                </div>

                <div class="px-8">
                    <a href="/opportunities/performances"
                        class="block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700 ">
                        View all performance listings
                    </a>
                </div>

            </div>

            <div class="pt-12 border border-t-0 border-b-2 border-x-0">
                <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div class="relative sm:overflow-hidden">

                        <div class="relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8">
                            <h4 class="text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl"
                                id="talent-profiles">
                                Talent Profiles
                            </h4>
                            <h2 class="pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl">
                                Network with theatre actors, singers and artistic staff
                            </h2>

                        </div>
                    </div>
                </div>

                <SkeletonCard class="mt-4" v-if="isFetching" card-style="long" :num-of-cards=2 />
                <div v-else
                    class="grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-x-8">
                    <div v-for="profile in getContentResponse.talentProfiles" :key="profile.id">
                        <TalentProfileCard :talent="profile" />
                    </div>
                </div>

                <div class="px-8">
                    <a href="/talent"
                        class="block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700 ">
                        View all talent profiles
                    </a>
                </div>

            </div>


            <div class="pt-12 border border-t-0 border-b-2 border-x-0">
                <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div class="relative sm:overflow-hidden">

                        <div class="relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8">
                            <h4 class="text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl"
                                id="theatre-companies">
                                Theatre Companies
                            </h4>
                            <h2 class="pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl">
                                Find performing arts companies and organizations
                            </h2>
                        </div>
                    </div>
                </div>

                <SkeletonCard class="mt-4" v-if="isFetching" card-style="long" :num-of-cards=2 />
                <div v-else
                    class="grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-x-8">
                    <div v-for="company in getContentResponse.theatreCompanies" :key="company.id">
                        <TheatreCompanyCard :company="company" />
                    </div>
                </div>

                <div class="px-8">
                    <a href="/theatre-companies"
                        class="block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700 ">
                        View all theatre companies
                    </a>
                </div>

            </div>


            <div class="pt-12 border border-t-0 border-b-2 border-x-0">
                <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                    <div class="relative sm:overflow-hidden">

                        <div class="relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8">
                            <h4 class="text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl"
                                id="college-theatre-programs">
                                College Theatre Programs
                            </h4>
                            <h2 class="pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl">
                                Directory of college theatre programs including degrees offered, majors available and
                                notable alumni
                            </h2>

                        </div>
                    </div>
                </div>

                <SkeletonCard class="mt-4" v-if="isFetching" card-style="long" :num-of-cards=2 />
                <div v-else
                    class="grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-x-8">
                    <div v-for="program in getContentResponse.collegePrograms" :key="program.id">
                        <CollegeProgramCard :program="program" />
                    </div>
                </div>

                <div class="px-8">
                    <a href="/college-programs"
                        class="block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700 ">
                        View all college theatre programs
                    </a>
                </div>

            </div>
        </div>


    </section>
</template>

<script lang="ts" setup>
// @ts-ignore
import {defineComponent, onMounted, ref, Ref} from "vue";
import {client} from '@/shared';
import {
    GetContentForCommunityLandingPageRequest, GetContentForCommunityLandingPageResponse
} from "@/dtos";
import OpportunityCard from "../Opportunities/OpportunityCard.vue";
import TalentProfileCard from "../Talent/TalentProfileCard.vue";
import TheatreCompanyCard from "../TheatreCompanies/TheatreCompanyCard.vue";
import CollegeProgramCard from "../CollegePrograms/CollegeProgramCard.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";

onMounted(async () => {
    await getContentForCommunityPage();
});

const getContentResponse: Ref<GetContentForCommunityLandingPageResponse>  = ref({});

const isFetching = ref(true);
const getContentForCommunityPage = async () => {
    await client.get<GetContentForCommunityLandingPageResponse>(new GetContentForCommunityLandingPageRequest())
        .then(response => {
            isFetching.value = false;
            getContentResponse.value = response;
        });
}
</script>